export default function CTASection() {
  return (
    <section className="relative py-24 overflow-hidden bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      {/* Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Icon */}
        <div className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-3xl flex items-center justify-center mx-auto mb-8">
          <i className="ri-customer-service-2-line text-5xl text-white"></i>
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight">
          M&A案件について<br />お気軽にご相談ください
        </h2>

        {/* Description */}
        <p className="text-xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto">
          経験豊富な専門スタッフが、お客様の状況に合わせた最適なM&Aプランをご提案いたします。<br />
          まずはお気軽にお問い合わせください。
        </p>

        {/* Contact Options */}
        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {/* Email */}
          <a
            href="mailto:info@nextage.jp"
            className="group bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 cursor-pointer"
          >
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-mail-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-black text-gray-900 mb-2">メールでお問い合わせ</h3>
            <p className="text-sm text-gray-600 mb-4">24時間受付中</p>
            <div className="flex items-center justify-center text-teal-600 font-bold">
              <span>info@nextage.jp</span>
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </div>
          </a>

          {/* LINE */}
          <a
            href="https://line.me/ti/p/your-line-id"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 cursor-pointer"
          >
            <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-line-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-black text-gray-900 mb-2">LINEでお問い合わせ</h3>
            <p className="text-sm text-gray-600 mb-4">お気軽にご相談</p>
            <div className="flex items-center justify-center text-green-600 font-bold">
              <span>友だち追加</span>
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </div>
          </a>
        </div>

        {/* Additional Info */}
        <div className="mt-12 bg-white/10 backdrop-blur-md rounded-2xl p-6 max-w-2xl mx-auto">
          <p className="text-white text-sm leading-relaxed">
            <i className="ri-shield-check-line text-xl mr-2"></i>
            ご相談内容は厳重に管理し、秘密保持を徹底いたします。安心してご相談ください。
          </p>
        </div>
      </div>
    </section>
  );
}
